import { render, staticRenderFns } from "./SvgPictoCopy.vue?vue&type=template&id=c23f0598"
import script from "./SvgPictoCopy.vue?vue&type=script&lang=ts"
export * from "./SvgPictoCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports